module.exports = __webpack_public_path__ + "img/6F5A9881.77f45a9c.png";